import { render } from "./MalibuLogo.vue?vue&type=template&id=0fe6c0e3&scoped=true"
import script from "./MalibuLogo.vue?vue&type=script&lang=js"
export * from "./MalibuLogo.vue?vue&type=script&lang=js"

import "./MalibuLogo.vue?vue&type=style&index=0&id=0fe6c0e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe6c0e3"]])

export default __exports__